import { useFeatureRollout } from '@rea-argonaut/experiment';
import { useAccountQuery } from '../../hooks/useAccountQuery';
import { isNotNullOrUndefinedValue } from '../../helpers/isNotNullOrUndefinedValue';

export const useShowAVMLoggedOut = () => {
  const accountQueryResult = useAccountQuery();
  const signedIn = isNotNullOrUndefinedValue(accountQueryResult.data?.account);
  const showAVMData = useFeatureRollout('show_avm_data').isEnabled() || signedIn;

  return showAVMData;
};
